import React from "react";
import { Spinner } from "../../atoms";
import { UrlList, OrderItemList } from "../../molecules";
import { Stack } from "@mui/material";

export const OrderItems = ({ data, isLoading }) => {
  return (
    <div className="top-space-details">
      <div className="new-orders-container set-height" id="details-screen-box">
        <div className="orders" id="align-column">
          <div className="item-container-parent">
            {data &&
              React.Children.toArray(
                data.map((item, index) => {
                  const costValue = item.price.toLocaleString({
                    maximumFractionDigits: 2,
                  });
                  return (
                    <div
                      className={
                        index !== data.length - 1
                          ? "product-item-container-border-bottom"
                          : "product-item-container"
                      }
                    >
                      <OrderItemList
                        topText={"Item Name"}
                        urlTrue={item.title && item.productUrl ? true : false}
                        text={item.title || "N/A"}
                        url={item.productUrl || "N/A"}
                        key={item.name}
                        quantity={item.quantity || "N/A"}
                        size={item.variantTitle || "N/A"}
                        cost={costValue || "N/A"}
                      />
                    </div>
                  );
                })
              )}
            <div className="spinnerDivDetails">
              <Spinner color={"black"} loading={isLoading} size={40} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
